import { useEffect,useState } from "react";
import {Table,Modal,DatePicker,Input,Button,Col,
  Row,Form,Empty,Typography,Select,Checkbox} from "antd";
import { SearchOutlined,FileSyncOutlined,CalendarFilled} from "@ant-design/icons";
import axios from "axios";
import {src,path} from "../network/conn";
import moment from "moment";
import "../css/report.css";
function Invoicereport(props){
    const [doctorDetails, setdoctorDetails] = useState([]);
    const [patientDetails, setpatientDetails] = useState([]);
    const [scanDetails, setscanDetails] = useState([]);
    const [loadingTaxReport,setLoadingTaxReport]=useState(false); 
    const [visibleTax,setVisibleTax]=useState(false);
    const [taxReportData, setTaxReportData] = useState([]);
    const [userSetting,setUserSetting] = useState({});
    const [FilterData, setFilterData] = useState([]);
  const [invoiceMethod, setinvoiceMethod] = useState(false);
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const {Option}=Select;
 var handleExcel = (function() {
  var uri = 'data:application/vnd.ms-excel;base64,'
    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns=""><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
    , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
    , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
  return function(table, name) {
    if (!table.nodeType) table = document.getElementById(table)
    var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
    window.location.href = uri + base64(format(template, ctx))
  }
})()
 const reportDateFetch=()=>{
     let patient = form.getFieldValue('patient');
     let doctor =  form.getFieldValue('doctor');
     let scan =  form.getFieldValue('scan');
   let dateVal = form.getFieldValue('date');
   console.log(dateVal);
   let fromDate = dateVal!=undefined?moment(dateVal[0]).format("YYYY-MM-DD"):"-";
   let toDate = dateVal!=undefined?moment(dateVal[1]).format("YYYY-MM-DD"):"-";
   console.log(patient,fromDate,toDate);
  let BaseURL = path + src + `fetch_invoice_report.php?&&fromdate=${fromDate}&&todate=${toDate}&&patient=${patient}&&doctor=${doctor}&&scan=${scan}`;
  axios
  .get(BaseURL)
  .then((response) => {
      setVisibleTax(true);
    setTaxReportData(response.data);
    setFilterData(response.data);
  })
  .catch((error) => console.log(error));
 }
 const handleGst=(e)=>{
if(e.target.checked==true)
{
    console.log("hai");
 let filterValue = FilterData.filter((list)=>{ return list.method!='est'});
 setFilterData(filterValue);
 console.log(filterValue);
}
if(e.target.checked==false)
{
    setFilterData(taxReportData);
}
 }
 const fetchDoctorDetails = () => {
      let BaseURL = path + src + "doctorlist.php";
      axios
        .get(BaseURL)
        .then((response) => {
          setdoctorDetails(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
  };
  const fetchPatientDetails = () => {
    let BaseURL = path + src + "patientlist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        setpatientDetails(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
};
const fetchScanDetails = () => {
    let BaseURL = path + src + "scanlist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        setscanDetails(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
};
 const closeModalPro=()=>{
  setVisibleTax(false);
  document.getElementById('reportHeading').innerHTML="";
  form.resetFields();
 }
 const profile = window.sessionStorage.getItem("profile");
 const fetch_profile_permission = (profile) =>{
   console.log('profile',profile);
   let BaseURL = path + src + "fetch_profile_permission.php?profile="+profile;
   axios
   .get(BaseURL)
     .then((response) => {
       console.log(response.data);
       let dataObj = {};
       response.data.map((list)=>{
         let permissionObj = {};
         if(list.filename == 'statementreport'){
         permissionObj['add']      = list.add;
         permissionObj['edit']     = list.edit;
         permissionObj['delete']   = list.delete;
         permissionObj['show']     = list.show;
         permissionObj['print']    = list.print;
         permissionObj['excel']    = list.excel;
         permissionObj['profile']  = list.profile;
         dataObj[list.filename]    =  permissionObj;
         setUserSetting(permissionObj);
         }
       })
      
      console.log('dataObj',dataObj);
     })
     .catch((error) => {
       //openMessageSuccess(error, 10);
       console.log(error);
     });
   }
    useEffect(()=>{
      fetch_profile_permission(profile);
        fetchDoctorDetails();
        fetchPatientDetails();
        fetchScanDetails();
    },[]);
    
    const taxReportColumn=[
      {
      key:"1",
      title:"Sno",
      dataIndex:"id",
  },
  {
    key:"2",
    title:"Date",
    dataIndex:"date",
},
  {
    key:"3",
    title:"Time",
    dataIndex:"time",
},
  {
      key:"4",
      title:"Code",
      dataIndex:"code",
  },
  {
    key:"5",
    title:"Patient Id",
    dataIndex:"patient",
},
  {
    key:"6",
    title:"Patient",
    dataIndex:"patientname",
},
  {
      key:"7",
      title:"Doctor",
      dataIndex:"doctor",
  },
  {
    key:"8",
    title:"Scan",
    dataIndex:"scan",
},
 {
    key:"9",
    title:"Process",
     dataIndex:"process",
},
// {
//     key:"10",
//     title:"Amount",
//     dataIndex:"amount",
// }
    ]
    
    return (<div className="reportTabe">
      <Modal 
          title={<div>REPORT <span>{Number(userSetting.excel) == 1 ? <Button type="danger" className="Excel" onClick={()=>handleExcel('ExcelReport','Invoice REPORT')}>EXCEL</Button> : ''}</span></div>}
        style={{ top: 20 }}
        visible={visibleTax}
        onOk={closeModalPro}
        onCancel={closeModalPro}
        className="fullModal"
        footer={null}
        maskClosable={false}>
         
            <div id="ExcelReport">
            <h3 id="reportHeading"></h3>
            
        <Table
        dataSource={FilterData}
        columns={taxReportColumn}
        pagination={false}
        loading={loadingTaxReport}
        // summary={(tableData) => {
        //     let taxValue=0;
        //     let eighteenTax = 0;
        //     let taxTotal= 0;
        //     let discount =0;
        //     tableData.map((tableData)=>{ 
        //         discount+=Number(tableData.discount);
        //         taxTotal+=Number(tableData.amount);})
        //     return (
        //     <>
        //       <Table.Summary.Row>
        //         <Table.Summary.Cell colSpan={5} />
        //         <Table.Summary.Cell colSpan={1}>
        //           Total
        //         </Table.Summary.Cell>
        //         <Table.Summary.Cell colSpan={1}>
        //           <Typography
        //             style={{ fontSize: "18px", fontWeight: "bold" }}
        //           >
        //            {discount.toFixed(2)}
        //           </Typography>
        //         </Table.Summary.Cell>
        //         <Table.Summary.Cell colSpan={1} align="center">
        //           <Typography
        //             style={{ fontSize: "18px", fontWeight: "bold"  }}
        //           >
        //            {taxTotal.toFixed(2)}
        //           </Typography>
        //         </Table.Summary.Cell>
        //       </Table.Summary.Row>
        //     </>
        //   ); }}
      ></Table>
      
        </div>
      </Modal>
      <h2>Report</h2>
        <Form layout="vertical" form={form} >
          <Row gutter={24}>
             
              <Col span={4}>
              <Form.Item
                  name="doctor"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="Select Doctor"
                  >
                    {doctorDetails.map((list) => (
                      <Option value={list.code}>
                        {list.doctor}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
              <Form.Item
                  name="patient"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="Select Patient"
                  >
                    {patientDetails.map((list) => (
                      <Option value={list.code}>
                         {`${list.code}/${list.patientname}`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
              <Form.Item
                  name="scan"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="Select Scan"
                  >
                    {scanDetails.map((list) => (
                      <Option value={list.code}>
                        {list.scan}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            <Col span={8}>
              <Form.Item
                name="date"
              >
                <RangePicker style={{width:"100%"}}/>
              </Form.Item>
            </Col>
            <Col span={2}>
              <Form.Item
               name="submit"
                //rules={[{ required: true, message: "Please enter user name" }]}
              >
                <Button type="primary" onClick={reportDateFetch}><CalendarFilled /></Button>
              </Form.Item>
            </Col>
            </Row>
            </Form>
            <Empty
    image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
    imageStyle={{
      height: 60,
    }}
    className="emptyContent"
    description={
      <span>
        Use Above Filters To Fetch Report
      </span>
    }
  >
  </Empty>,
    
    </div>)
}
export default Invoicereport;